import { useLocation, useHistory } from 'react-router-dom';
import queryString, { ParsedQuery } from 'query-string';
import _omit from 'lodash/omit';

interface OnHashParamPush {
  [key: string]: any;
}

type OnHashParamPushFunction = (
  keyValuePair: OnHashParamPush,
  pathsToOmit?: string[],
) => any;

/**
 * @description Handles adding hash query params to the URL for you.
 */
export function useHashParams(): [
  ParsedQuery<string>,
  OnHashParamPushFunction,
] {
  const location = useLocation();
  const history = useHistory();

  function onHashParamPush(qps: OnHashParamPush, pathsToOmit?: string[]) {
    // Don't overwrite current hash params
    const currentHashParams = {
      ...queryString.parse(location.hash),
      ...qps,
    };
    history.push({
      // @ts-expect-error This directive was added as part of a bulk-change to enable strictNullChecks.
      hash: queryString.stringify(_omit(currentHashParams, pathsToOmit)),
      search: location.search,
    });
  }

  const hashParams = queryString.parse(location.hash);

  return [hashParams, onHashParamPush];
}

export default useHashParams;
